import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  
    title: {
      fontSize: '16px',
      marginLeft: '2%',
      marginBottom:'0%',
      marginTop:'0%',
      fontFamily:'Open Sans'
    },
    
    content: {
      fontSize: '16px',
      marginLeft: '2%',
      marginBottom:'8%',
      marginTop:'5%',
      fontFamily:'Open Sans'
    },

    buttons: {
      marginTop: '4%',
      width: '165,34px',
      height: '35px'
    },

    
  
   
    modal: {
      maxWidth: '510px',
      width:'80%',
      height: '100%',
      marginLeft: '3%',
      maxHeight: '198px',
      overflow: 'hidden',
      marginTop:'15%'
      
    
    },
    divider: {
      color:'#000',
      opacity: '0.3',
      marginBottom: '-10px'
    },
  
    svg: (props:any) => ({
      fill: '#999999',
      '&:hover': {
        fill: props.color
      }
    }),
   
  
  
  
   
  }); 